import { css } from '@/styled-system/css';

export const popoverCloseButtonStyles = css.raw({
  position: 'absolute',
  insetBlockStart: 'Popover.CloseButton.margin.top',
  insetInlineEnd: 'Popover.CloseButton.margin.right',
  zIndex: 100,
});
